export const FEATURE_LIST_IMAGE_POSITION = {
  LEFT: 'left',
  RIGHT: 'right'
} as const;

export const FEATURE_LIST_IMAGE_POSITION_OPTIONS = [
  { label: 'Right', value: FEATURE_LIST_IMAGE_POSITION.RIGHT },
  { label: 'Left', value: FEATURE_LIST_IMAGE_POSITION.LEFT }
] as const;

export const FEATURE_LIST_IMAGE_LAYOUT_CONSTANTS = {
  MAX_SCAN: 50,
  DEFAULT_ALT_SIDE_IMAGE: 'Section image',
  DEFAULT_ALT_FEATURE_ICON: 'Feature icon',
  LAYOUT_LABEL: 'Feature List With Side Image',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1785240678279.png',
  LAYOUT_DESCRIPTION:
    'Two-column section with heading, subheading, side image and icon feature list',
  IMAGE_POSITION_LABEL: 'Image Position',
  IMAGE_POSITION_FIELD_NAME: 'image_position',
  SIDE_IMAGE_SIZE_PX: 600
} as const;
